import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PostsService } from 'src/app/service/posts.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit-other-post-details',
  templateUrl: './edit-other-post-details.component.html',
  styleUrl: './edit-other-post-details.component.scss'
})
export class EditOtherPostDetailsComponent {

  constructor(private route: ActivatedRoute, private postsService: PostsService) { }
  details: any;
  id: any;
  otherDetails: Array<any> = [];
  fileSizeInBytes: any;
  public selectedFileVehicelReg: any = File;
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['id'];

      this.postsService.getOtherSubDetailsById(this.id).subscribe(res => {
        this.details = res;

      })
    });
  }


  onFileSelectedVehicleReg(event: any) {
    const file = event.target.files[0];
    this.fileSizeInBytes = file.size;
    if (this.fileSizeInBytes > 10485760) {
      Swal.fire({
        title: 'Size of image should be less than 10240kb!',
      }).then((result) => {
      })
    } else {
      this.selectedFileVehicelReg = file;
    }


  }





  //*******************Other Details ************* */
  @ViewChild('title') title!: ElementRef;
  @ViewChild('img') OtherImg!: ElementRef<HTMLInputElement>;
  submitOtherDetails(title:any,videoLink:any,otherDescription:any) {
    if (title == '') {
      Swal.fire({
        title: 'Please enter title!',
      }).then((result) => {
      })
    }
    
    else {
      let details = {
        'title': title,
        'videoLine': videoLink,
        'otherDescription': otherDescription,
        'id': this.id
      }

      const uploadFormData = new FormData();
      // uploadFormData.append('file', this.selectedFileVehicelReg);
      uploadFormData.append('details', JSON.stringify(details));
      this.postsService.editOtherDetails(uploadFormData,this.id).subscribe(res => {
        var status = res.status;
        if (status == 'success') {
          Swal.fire({
            title: 'Successfully updated details!',
          }).then((result) => {
            //  this.title.nativeElement.value = '';
            // this.OtherImg.nativeElement.dispatchEvent(new Event('change'));

          })
        } else {
          Swal.fire({
            title: 'Error with updating the details!',
          }).then((result) => {

          })
        }
      })
    }

  }

  deleteImage(){
    Swal.fire({
  title: 'Are you sure you want to delete the image?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: 'Yes, delete it!',
  cancelButtonText: 'Cancel'
}).then((result) => {
  if (result.isConfirmed) {
     this.postsService.deleteOtherImage(this.id).subscribe(res => {
        var status = res.status;
        if (status == 'success') {
          Swal.fire({
            title: 'Successfully deleted the image!',
          }).then((result) => {
            location.reload();
          })
        } else {
          Swal.fire({
            title: 'Error with deleting the image!',
          }).then((result) => {

          })
        }
      })
  }
});


  }


  saveImageChanges() {
    if (this.selectedFileVehicelReg == '') {
      Swal.fire({
            title: 'Please select image to update!',
          }).then((result) => {

          })
    } else {
      const uploadFormData = new FormData();
      uploadFormData.append('file', this.selectedFileVehicelReg);
      let details = {
        'id': this.id,

      }
      uploadFormData.append('details', JSON.stringify(details));

      this.postsService.editOtherImage(uploadFormData).subscribe(res => {
        var status = res.status;
        if (status == 'success') {
          Swal.fire({
            title: 'Successfully editted the image!',
          }).then((result) => {
            location.reload();
          })
        } else {
          Swal.fire({
            title: 'Error with editing the image!',
          }).then((result) => {

          })
        }
      })
    }

  }

}
